// -> IIngestionManager (ImportController). UC-5, UC-22, UC-23.
//
// The two upload routes bind a multipart form whose only field is `workbook`; every other
// argument travels as a query parameter (ImportController.cs's own header explains why: a file
// beside scalar form fields cannot be described by the Swashbuckle generator this API uses,
// D-205's accepted consequence). A caller who exceeds D-218's configured cap gets back an
// ApiError with kind "payloadTooLarge" (413) - see ApiError.ts.
import { http } from "./http";
import type { ExternalSyncRequest, ImportPreview, ImportResult, SourceComparison, SyncResult, DualRunRequest } from "./generated/contracts";

function workbookForm(file: File): FormData {
  const form = new FormData();
  form.append("workbook", file, file.name);
  return form;
}

export const ingestionApi = {
  previewWorkbook: (file: File, sourceProfileCode?: string, tabNames?: readonly string[]) =>
    http.post<ImportPreview>("/api/import/preview", {
      body: workbookForm(file),
      query: { sourceProfileCode, tabNames },
    }),

  commitWorkbook: (
    file: File,
    previewKey: string,
    acceptWarnings: boolean,
    sourceProfileCode?: string,
    tabNames?: readonly string[],
  ) =>
    http.post<ImportResult>("/api/import/commit", {
      body: workbookForm(file),
      query: { previewKey, acceptWarnings, sourceProfileCode, tabNames },
    }),

  runExternalSync: (request: ExternalSyncRequest) => http.post<SyncResult>("/api/import/sync", { body: request }),

  compareSources: (request: DualRunRequest) => http.post<SourceComparison>("/api/import/compare", { body: request }),
};
